export function getBackrefAppeals() {
  return '/appeals/list';
}
